var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as SharedStyle from '../../shared-style';

//http://www.cssportal.com/css-tooltip-generator/

var STYLE = {
  width: '50px',
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '20px',
  position: 'relative',
  cursor: 'pointer',
  padding: '25px',
  backgroundColor: '#555',
  marginBottom: '3px',
  flexDirection: 'column'
};

// const STYLE_TOOLTIP = {
//   position: 'absolute',
//   width: '140px',
//   color: SharedStyle.COLORS.white,
//   background: SharedStyle.COLORS.black,
//   height: '30px',
//   lineHeight: '30px',
//   textAlign: 'center',
//   visibility: 'visible',
//   borderRadius: '6px',
//   opacity: '0.8',
//   left: '100%',
//   top: '50%',
//   marginTop: '-15px',
//   marginLeft: '15px',
//   zIndex: '999',
//   fontSize: '12px'
// };

// const STYLE_TOOLTIP_PIN = {
//   position: 'absolute',
//   top: '50%',
//   right: '100%',
//   marginTop: '-8px',
//   width: '0',
//   height: '0',
//   borderRight: '8px solid #000000',
//   borderTop: '8px solid transparent',
//   borderBottom: '8px solid transparent'
// };

var ToolbarButton = function (_Component) {
  _inherits(ToolbarButton, _Component);

  function ToolbarButton(props, context) {
    _classCallCheck(this, ToolbarButton);

    var _this = _possibleConstructorReturn(this, (ToolbarButton.__proto__ || Object.getPrototypeOf(ToolbarButton)).call(this, props, context));

    _this.state = { active: false };
    return _this;
  }

  _createClass(ToolbarButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var state = this.state,
          props = this.props;

      var color = props.active || state.active ? SharedStyle.SECONDARY_COLOR.icon : SharedStyle.PRIMARY_COLOR.icon;

      return React.createElement(
        'div',
        { style: _extends({}, STYLE, { backgroundColor: props.backgroundColor ? props.backgroundColor : '#555' }),
          onMouseOver: function onMouseOver(event) {
            return _this2.setState({ active: true });
          },
          onMouseOut: function onMouseOut(event) {
            return _this2.setState({ active: false });
          },
          onClick: props.onClick },
        React.createElement(
          'div',
          { style: { color: color } },
          props.children
        ),
        React.createElement(
          'div',
          { style: { fontSize: 11, color: SharedStyle.PRIMARY_COLOR.icon } },
          props.name
        )
      );
    }
  }]);

  return ToolbarButton;
}(Component);

export default ToolbarButton;


ToolbarButton.propTypes = {
  active: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isTooltipVisible: PropTypes.bool.isRequired
};